import React, { useRef, useState } from "react";
import { CCard, CCardBody, CButton } from "@coreui/react";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.min.css";

// Shared date-range dropdown used by the transaction-breakdown dashboard
// cards. Same look and behaviour as the dropdowns embedded in the older
// cards (OrdersCard, PaymentMethodCard, ...).
const DateRangeDropdown = ({ dateRange, setDateRange }) => {
  const dropdownRef = useRef(null);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [tempDateRange, setTempDateRange] = useState(dateRange);
  const [activeButton, setActiveButton] = useState(null);

  const handleDateChange = (selectedDates) => {
    if (selectedDates.length === 2) {
      setTempDateRange(selectedDates);
      setActiveButton(null);
    }
    // Prevent dropdown from closing
    setDropdownVisible(true);
  };

  const applyDateRange = () => {
    setDateRange(tempDateRange);
    setDropdownVisible(false);
  };

  const setDateRangeToToday = () => {
    const today = new Date();
    setTempDateRange([today, today]);
  };

  const setDateRangeToThisWeek = () => {
    const today = new Date();
    const firstDayOfWeek = new Date(
      today.setDate(today.getDate() - today.getDay())
    );
    const lastDayOfWeek = new Date(
      today.setDate(today.getDate() - today.getDay() + 6)
    );
    setTempDateRange([firstDayOfWeek, lastDayOfWeek]);
  };

  const setDateRangeToThisMonth = () => {
    const today = new Date();
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    const lastDayOfMonth = new Date(
      today.getFullYear(),
      today.getMonth() + 1,
      0
    );
    setTempDateRange([firstDayOfMonth, lastDayOfMonth]);
  };

  const resetDateRange = () => {
    const start = new Date();
    start.setMonth(start.getMonth() - 5);
    start.setDate(1);
    start.setHours(0, 0, 0, 0);

    const end = new Date();
    end.setMonth(end.getMonth() + 1);
    end.setDate(0);
    end.setHours(23, 59, 59, 999);

    setTempDateRange([start, end]);
  };

  const handleButtonClick = (rangeSetter, buttonId) => {
    rangeSetter();
    setActiveButton(buttonId);
  };

  const formatDateRange = (range) => {
    if (range.length === 2) {
      return `${range[0]
        .toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        })
        .replace(/ /g, "-")} - ${range[1]
        .toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        })
        .replace(/ /g, "-")}`.toUpperCase();
    }
    return "Select Date Range";
  };

  return (
    <div
      ref={dropdownRef}
      style={{
        display: "flex",
        justifyContent: "center",
        padding: "6px",
        borderRadius: "5px",
        width: "340px",
        margin: "10px auto",
        marginBottom: "-20px",
        position: "relative",
      }}
    >
      <CButton
        style={{
          border: "0px solid lightgrey",
          backgroundColor: "#F8F5F5",
          borderRadius: "5px",
          color: "#343333",
          height: "45px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
          transition: "background-color 0.3s",
        }}
        color="primary"
        onClick={() => setDropdownVisible(!dropdownVisible)}
        onMouseEnter={(e) => {
          e.target.style.backgroundColor = "#e0e0e0";
          const icon = e.target.querySelector("i");
          if (icon) {
            icon.style.backgroundColor = "#e0e0e0";
          }
        }}
        onMouseLeave={(e) => {
          e.target.style.backgroundColor = "#F8F5F5";
          const icon = e.target.querySelector("i");
          if (icon) {
            icon.style.backgroundColor = "#F8F5F5";
          }
        }}
      >
        {formatDateRange(dateRange)}
        <i
          className={`bi bi-chevron-down ${dropdownVisible ? "rotate" : ""}`}
          style={{ marginLeft: "10px" }}
        ></i>
      </CButton>
      {dropdownVisible && (
        <CCard
          className="border-light"
          style={{
            position: "absolute",
            top: "50px",
            zIndex: 1000,
            width: "400px",
          }}
        >
          <CCardBody style={{ overflowX: "auto" }}>
            <span>Filter By Date Range</span>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
                padding: "10px",
                borderRadius: "5px",
                width: "100%",
                margin: "0px auto",
                position: "relative",
              }}
            >
              <Flatpickr
                options={{ mode: "range", dateFormat: "d/m/Y" }}
                value={tempDateRange}
                onChange={handleDateChange}
                className="form-control"
                style={{
                  border: "1px solid lightgrey",
                  backgroundColor: "white",
                  color: "#555E67",
                  borderRadius: "10px",
                  width: "100%",
                  height: "45px",
                  transition: "background-color 0.3s",
                }}
                onMouseEnter={(e) =>
                  (e.target.style.backgroundColor = "#e0e0e0")
                }
                onMouseLeave={(e) =>
                  (e.target.style.backgroundColor = "white")
                }
              />
              <i
                className={`bi bi-calendar`}
                style={{
                  position: "absolute",
                  right: "20px",
                  top: "50%",
                  transform: "translateY(-50%)",
                }}
              ></i>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-around",
                marginTop: "0px",
              }}
            >
              <CButton
                color="secondary"
                onClick={() => handleButtonClick(setDateRangeToToday, "today")}
                style={{
                  border: "1px solid lightgrey",
                  backgroundColor:
                    activeButton === "today" ? "#0B4FE4" : "white",
                  borderRadius: "10px",
                  color: activeButton === "today" ? "white" : "#555E67",
                  width: "30%",
                  height: "45px",
                  cursor: "pointer",
                  transition: "background-color 0.3s",
                }}
                onMouseEnter={(e) =>
                  (e.target.style.backgroundColor =
                    activeButton === "today" ? "#0056b3" : "#e0e0e0")
                }
                onMouseLeave={(e) =>
                  (e.target.style.backgroundColor =
                    activeButton === "today" ? "#007bff" : "white")
                }
              >
                Today
              </CButton>
              <CButton
                color="secondary"
                onClick={() =>
                  handleButtonClick(setDateRangeToThisWeek, "thisWeek")
                }
                style={{
                  border: "1px solid lightgrey",
                  backgroundColor:
                    activeButton === "thisWeek" ? "#0B4FE4" : "white",
                  borderRadius: "10px",
                  color: activeButton === "thisWeek" ? "white" : "#555E67",
                  width: "30%",
                  height: "45px",
                  cursor: "pointer",
                  transition: "background-color 0.3s",
                }}
                onMouseEnter={(e) =>
                  (e.target.style.backgroundColor =
                    activeButton === "thisWeek" ? "#0056b3" : "#e0e0e0")
                }
                onMouseLeave={(e) =>
                  (e.target.style.backgroundColor =
                    activeButton === "thisWeek" ? "#007bff" : "white")
                }
              >
                This Week
              </CButton>
              <CButton
                color="secondary"
                onClick={() =>
                  handleButtonClick(setDateRangeToThisMonth, "thisMonth")
                }
                style={{
                  border: "1px solid lightgrey",
                  backgroundColor:
                    activeButton === "thisMonth" ? "#0B4FE4" : "white",
                  borderRadius: "10px",
                  color: activeButton === "thisMonth" ? "white" : "#555E67",
                  width: "30%",
                  height: "45px",
                  cursor: "pointer",
                  transition: "background-color 0.3s",
                }}
                onMouseEnter={(e) =>
                  (e.target.style.backgroundColor =
                    activeButton === "thisMonth" ? "#0056b3" : "#e0e0e0")
                }
                onMouseLeave={(e) =>
                  (e.target.style.backgroundColor =
                    activeButton === "thisMonth" ? "#007bff" : "white")
                }
              >
                This Month
              </CButton>
            </div>
            <hr></hr>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "10px",
              }}
            >
              <CButton
                color="secondary"
                onClick={() => {
                  resetDateRange();
                  setActiveButton(null);
                }}
                style={{
                  border: "1px solid #0B4FE4",
                  backgroundColor: "white",
                  borderRadius: "5px",
                  color: "#0B4FE4",
                  width: "45%",
                  height: "50px",
                  cursor: "pointer",
                  transition: "background-color 0.3s",
                }}
                onMouseEnter={(e) =>
                  (e.target.style.backgroundColor = "#e0e0e0")
                }
                onMouseLeave={(e) => (e.target.style.backgroundColor = "white")}
              >
                Reset
              </CButton>
              <CButton
                color="primary"
                onClick={applyDateRange}
                style={{
                  border: "1px solid lightgrey",
                  backgroundColor: "#0B4FE4",
                  borderRadius: "5px",
                  color: "white",
                  width: "45%",
                  height: "50px",
                  cursor: "pointer",
                  transition: "background-color 0.3s",
                }}
                onMouseEnter={(e) =>
                  (e.target.style.backgroundColor = "#083bb3")
                }
                onMouseLeave={(e) =>
                  (e.target.style.backgroundColor = "#0B4FE4")
                }
              >
                Apply
              </CButton>
            </div>
          </CCardBody>
        </CCard>
      )}
    </div>
  );
};

export default DateRangeDropdown;
